import React from "react";
import AddFeed from "./AddFeed";
import SubmitFeed from "./AddFeed/Networks/Elements/SubmitFeed";
import { isFbHashtagFilter, TOAST_ERROR } from "../../../../../../../utils";

class FilterContent extends React.Component {
    updatedSourceFilter = (filter) => {
        const { updatedSelectedFilter } = this.props;
        updatedSelectedFilter(filter);
    }

    render() {
        const { filterTabs, selectedFilterId, updateStep, selectedNetworkId, backAction } = this.props;
        const FbHashtag = isFbHashtagFilter(selectedNetworkId, selectedFilterId);

        return (
            <div className="ob-panel-body panel-body-p">
                <h4 className="ob-panel-title">Select preferred source type</h4>
                <p className="ob-panel-subtitle">Select the social platform from which you want to add the feeds</p>

                <ul className="ob-filter-tabs d-flex flex-wrap mb-0 p-0">
                    {filterTabs.length > 1 ? filterTabs.map((item, index) => {
                        const { feedName, filter, feedtype } = item;
                        return !feedtype.includes('advanced') ? <li className={`${selectedFilterId == filter ? 'active' : ''} cursor-pointer position-relative`} onClick={() => this.updatedSourceFilter(item)} key={`${index}-${feedName}`}>
                            <span className="d-block text-nowrap position-relative">{feedName}</span>
                        </li> : null
                    }) : null}
                </ul>

                <div className="mt-3">
                    {FbHashtag ? (
                        <SubmitFeed loading={false} onSubmit={() => { }} onBack={backAction} disabled={true} hideSubmit={true} />
                    ) : selectedFilterId ? (
                        <AddFeed selectedFilterId={selectedFilterId} updateStep={updateStep} selectedNetworkId={selectedNetworkId} backAction={backAction} />
                    ) : (
                        <SubmitFeed loading={false} onSubmit={() => TOAST_ERROR('Please select a source type to collect content')} onBack={backAction} disabled={true} />
                    )}
                </div>
            </div>
        );
    }
}

export default FilterContent;
